import React from "react";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";
import { Grid, Paper, Stack } from "@mui/material";
import styled from "styled-components";
import ConfigTable from "src/scenes/deployments-config-all/config-table";
import GeneralConfigSection from "src/scenes/deployments-config-all/general-config-section";

const CustomPaper = styled(Paper)`
    border-radius: 14px;
    width: 100%;
    min-height: 164px;
    z-index: 100;
`;

const PaperTitle = styled.p`
    margin: 0;
    padding: 11px 0 10px 18px;
    font-size: 13px;
    font-weight: 500;
    background-color: #5b5b5b;
    border-radius: 14px 14px 0 0;
`;
const DeploymentsConfigAll = () => {
    const [userSettings, setUserSettings] = React.useState();
    const [orgSettings, setOrgSettings] = React.useState();
    const [teamsSettings, setTeamsSettings] = React.useState();
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const getAllConfigurationSettings = async () => {
        const response = await request(`/api/data/all/deployment-configuration`, { method: "GET" });
        setUserSettings(response.user);
        setOrgSettings(response.org);
        setTeamsSettings(response.teams);
    };

    const handleGetAllConfiguration = async () => {
        try {
            getAllConfigurationSettings();
        } catch (e) {
            setMessage(`Error retrieving deployment configuration. Please try again.`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    React.useEffect(() => {
        handleGetAllConfiguration();
    }, []);

    if (!userSettings || !orgSettings || !teamsSettings) return null;

    return (
        <Stack direction="column" mb={8} style={{ width: "100%", height: "100%" }}>
            <p style={{ opacity: "0.5", marginBottom: "47px" }}>
                Personal & company wide deployment configurations
            </p>
            <Grid container>
                <Grid item mb={5} md={12}>
                    <CustomPaper>
                        <PaperTitle>Personal deployments configuration</PaperTitle>
                        <GeneralConfigSection data={userSettings.general} type="user" />
                        <ConfigTable data={userSettings.perRepo} />
                    </CustomPaper>
                </Grid>
                <Grid item mb={5} md={12}>
                    <CustomPaper>
                        <PaperTitle>Company-wide deployments configuration</PaperTitle>
                        <GeneralConfigSection data={orgSettings.general} type="org" />
                        <ConfigTable data={orgSettings.perRepo} />
                    </CustomPaper>
                </Grid>
                <p style={{ opacity: "0.5", marginBottom: "47px" }}>
                    Teams deployment configurations
                </p>
                {teamsSettings &&
                    teamsSettings.map((team) => {
                        return (
                            <Grid item mb={5} md={12}>
                                <CustomPaper>
                                    <PaperTitle>
                                        {team.teamName} deployments configuration
                                    </PaperTitle>
                                    <GeneralConfigSection data={team.general} type="teams" />
                                    <ConfigTable data={team.perRepo} />
                                </CustomPaper>
                            </Grid>
                        );
                    })}
            </Grid>
        </Stack>
    );
};

export default DeploymentsConfigAll;
